import { Controller } from "@hotwired/stimulus"
// import tippy from 'tippy.js';

export default class extends Controller {
  connect() {
    // console.log("card_controller.js");
    // tippy('#price_description', {
    //   content: 'My tooltip!',
    // });
  }
}
